module.exports = __webpack_public_path__ + "img/mainImg.a4f8878c.png";